import React from 'react'
import { Navbar } from '../component/Navbar/Navbar'
import { Footer } from '../component/Footer/Footer'
import { About_block } from '../component/About/About_block'

export const About = () => {
    return (
        <div>
            <Navbar/>
            <About_block/>
            <Footer/>
            
        </div>
    )
}
